import {useCustomQuery} from "~/query/queryClient";
import {queryHttp} from "~/query/queryHttp";
import type {PageResponse} from "~/services/ApiTypes";
import {supplierRelationshipUrl} from "~/pages/supplier-360/services/supplier360Urls";
import type {SupplierRelationship} from "~/pages/supplier-360/types/Supplier360Types";

/** Corporate-structure edges from one entity (`GET supplier_360/relationship/?from_entity={id}`). */
export function useSupplierRelationshipsQuery(entityId: number | undefined) {
    const url = supplierRelationshipUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<PageResponse<SupplierRelationship>>(url)).data.results,
        enabled: Boolean(entityId),
    });
}
